import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {
  transform(value: number): string {
    if (value <= 0)
      return;

    const minutes: number = Math.floor(value / 60);
    return (
      (minutes > 0 ? (minutes + "min ") : "") +
      ("00" + Math.floor(value - minutes * 60)).slice(-2) + "seg"
    );
  }
}
